import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

export default function NinthPage(){

	const navigate = useNavigate();

	const [blurState, setBlurState] = useState([5, 5, 5, 5, 5]);

	const [flickerText, setFlickerText] = useState(false);

	const handleFlicker = (value) => {
	  if (value === true) {
		 setFlickerText(false);
	  } else {
		 setFlickerText(true);
	  }
	};
 
	useEffect(() => {
	  const interval = setInterval(() => {
		 handleFlicker(flickerText);
	  }, 1000);
 
	  return () => clearInterval(interval); // Cleanup on unmount
	}, [flickerText]); // Dependency on flickerText
 
	const handleUnblur = (index) => {
		const newBlurState = [...blurState];
		newBlurState[index] = 0;
		setBlurState(newBlurState);
	}

	let content;
	if (flickerText === true) {
		content = (
		  <h1 className="title text-4xl font-bold text-white" style={{borderBottom: "1px solid blue"}} id="tenth-title">
			 Η πραγματική ειρήνη!
		  </h1>
		);
	 } else {
		content = (
			<h1 className="title text-4xl font-bold text-white" style={{borderBottom: "1px solid blue"}} id="tenth-title">
			Η πραγματική <span className='flicker' style={{color: "yellow"}}>ειρήνη!</span>
		 	</h1>
		)
	 }

	return(
		<div className='App' style={{background: "rgb(113,199,236)"}}>
			
			{content}

			<br />
			
			<p
				className='p-container'
				style={{color:'rgb(22, 22, 22)', filter:`blur(${blurState[0]}px)`}}
				onClick={() => handleUnblur(0)}
			>
				Συνεχίζουμε τη γνωριμία μας, μια γνωριμία που δεν θα τελειώσει ποτέ. Χρειάζεται μια ολόκληρη ζωή για να ολοκληρωθεί. Μέσα από αυτή, 
				φυσικά, ανακάλυψα το πάθος σου για τον Θεό μας, τον Χριστό μας και την Παναγία μας! Ωστόσο, το πάθος σου για τον Θεό ήταν καλυμμένο από 
				κακές επιρροές, ντροπή και πολλές άλλες παγίδες των πονηρών πνευμάτων. Ποιο ήταν το αποτέλεσμα; Δεν πήγαινες για εξομολόγηση! Τόσα 
				χρόνια κουβαλούσες αυτό το αβάσταχτο βάρος... Δεν μπορώ να φανταστώ τον πόνο που ένιωθες στη γλυκιά σου ψυχή, τη θλίψη και την ταλαιπωρία. 
				Αν συνέχιζες αυτόν τον δρόμο, σίγουρα δεν θα είχε καλή κατάληξη.
			</p>

			<br />

			<p
				className='p-container'
				style={{color:'rgb(22, 22, 22)', filter:`blur(${blurState[1]}px)`}}
				onClick={() => handleUnblur(1)}
			>
				Μια ηλιόλουστη, πανέμορφη μέρα, μέσα στο γέλιο και τη χαρά μας, σε ρώτησα αν εξομολογείσαι και σου είπα ότι εγώ πηγαίνω σε έναν πατέρα 
				εδώ κοντά. Μου απάντησες πως δεν είχες πάει ποτέ. Έτσι, έμαθες για την εξομολόγηση. Από τα λεγόμενά σου, φάνηκε ότι τότε δεν γνώριζες τη 
				δύναμη και τη σημασία της. Ακολουθούσες λανθασμένα βήματα, που οδηγούσαν στην αυτοκαταστροφή. Και βαθιά μέσα σου, το ήξερες. Τόσο μεγάλη 
				είναι η αγάπη σου για τον Κύριό μας, που αναγνώρισες εύκολα ότι η εξομολόγηση είναι ένα από τα δώρα Του προς εμάς, τους αμαρτωλούς, 
				για να νικήσουμε το κακό και να ενωθούμε μαζί Του!
			</p>

			<br />
			
			<p
				className='p-container'
				style={{color:'rgb(22, 22, 22)', filter:`blur(${blurState[2]}px)`}}
				onClick={() => handleUnblur(2)}
			>
				Σου εξήγησα τι διδάσκει η Αγία μας Εκκλησία για την εξομολόγηση: ότι μέσω αυτής ο Θεός μας προσφέρει το μέγα έλεός Του και συγχωρεί τις αμέτρητες 
				αμαρτίες μας. Ότι είναι απαραίτητη για τη σωτηρία μας και πως ο πατέρας, πάντοτε φωτισμένος από το Άγιο Πνεύμα, μας καθοδηγεί. Ότι μόνο με την 
				ευλογία του μπορούμε να φανούμε, έστω και λίγο, άξιοι να λάβουμε το Σώμα και το Αίμα του Κυρίου μας! Όταν σου τα είπα αυτά, ο πονηρός 
				αμέσως σου επιτέθηκε. Φοβήθηκε! Δεν ήθελε με κανέναν τρόπο να ξεκινήσεις μια νέα συνήθεια που θα οδηγούσε στη λύτρωση της γλυκιάς και γεμάτης 
				αγάπη ψυχής σου. Γι’ αυτό, στην αρχή, τρόμαξες, δίστασες. Έφερες αντιρρήσεις... δεν ήθελες να ακούσεις με τίποτα.
			</p>

			<br />

			<p
				className='p-container'
				style={{color: 'rgb(22, 22, 22)', filter: `blur(${blurState[3]}px)`}}
				onClick={() => handleUnblur(3)}
			>
				Περνούν οι μέρες. Ο Θεός με αξίωσε να σταθώ καλό παράδειγμα και να συνεχίσω την εξομολόγηση, μιλώντας σου γι’ αυτήν με αγάπη και στοργή, χωρίς πίεση ή 
				κατάκριση. Με κατανόηση και κρυφή προσευχή για την ψυχή σου και την ειρήνη σου. Έτσι, ξαφνικά, αφού έκανα ό,τι μπορούσα ανθρωπίνως, ο Θεός μας έκανε το 
				δικό Του έργο και απομάκρυνε τον φόβο από την ψυχή σου. Μου είπες από μόνη σου ότι θέλεις να εξομολογηθείς! Κατάλαβες πως η ντροπή για το παρελθόν σου 
				σε κρατούσε πίσω. Και σε εκείνο το σημείο, ο Καλός Θεός μας μού έδωσε τη δύναμη να σταθώ σωστά απέναντί σου, όταν μου εξέφρασες τις ανησυχίες σου και 
				τις αμαρτίες σου. Εκεί, εύκολα οι δικές μου ανασφάλειες θα μπορούσαν να με οδηγήσουν στην κατάκριση και να σε απομακρύνουν από τον δρόμο της εξομολόγησης 
				και της μετάνοιας. Όμως, η αγάπη μου για σένα, δώρο και ικανότητα από τον Θεό μας, υπερίσχυσε. Μπόρεσα να δω πέρα από το παρελθόν σου και να διακρίνω το 
				μέλλον της ψυχής σου, αν μετανοήσεις! Πώς μπορείς να αλλάξεις και ότι αυτό είναι ένας προσωπικός σου αγώνας με τον Θεό! Ο δικός σου αγώνας!
			</p>

			<br />

			<p
				className='p-container'
				style={{color: 'rgb(22, 22, 22)', filter: `blur(${blurState[4]}px)`}}
				onClick={() => handleUnblur(4)}
			>
				Μετά από αυτό το συγκινητικό γεγονός για σένα, τόσο σημαντικό για τη μικρή Χρύσα που κρύβεις μέσα σου, ταλαιπωρημένη και τρομαγμένη, σηκώθηκες! 
				Αποφάσισες να κάνεις υπακοή σε ένα απλό αγόρι που γνώριζες μόλις δύο μήνες. Παρά τον φόβο σου, εμπιστεύτηκες τα λόγια μου και τον Θεό και πήγες. 
				Πήγες να εξομολογηθείς στον πατέρα που σου πρότεινα! Πραγματικά, από την πλευρά μου, ήταν απίστευτο... γιατί είδα την απόλυτη υπακοή και τον σεβασμό 
				σου προς εμένα. Είδα την αγάπη σου και την εμπιστοσύνη που μου έχεις, ως κεφάλι της νέας ανθρώπινης σχέσης που χτίσαμε. Αυτό το χαρακτηριστικό 
				είναι πρωτόγνωρο για μένα, και σε θαυμάζω για το πώς μπορείς να αφήνεις στην άκρη το «εγώ» σου, να ακούς προσεκτικά αυτά που λέω και 
				να τα κάνεις πράξη. Σε αγαπώ απεριόριστα και εκτιμώ βαθιά την εμπιστοσύνη σου. Από την πλευρά μου, σου υπόσχομαι ότι θα προσπαθώ πάντα να 
				ανταποδίδω, γινόμενος καλύτερος άντρας, ένας άντρας στον ώμο του οποίου μπορείς να αναπαυθείς, να αντλήσεις δύναμη, ώστε να συνεχίσουμε μαζί τον 
				δύσκολο αγώνα που λέγεται ζωή. Και αυτή τη φορά, θα είναι μια ζωή εν Χριστώ!
			</p>

			<button className='myBtn' onClick={() => navigate('/heart')}>I Love You To Death Χρύσα</button>

			<br />

		</div>
	);
}